import { useMemo } from "react";
import {
  useNavigate,
  useLocation,
  useSearchParams as useRouterSearchParams,
} from "react-router-dom";

/** Next-style router surface for incremental migration from `next/navigation`. */
export function useRouter() {
  const navigate = useNavigate();
  return useMemo(
    () => ({
      push: (to: string) => void navigate(to),
      replace: (to: string, opts?: { scroll?: boolean }) => {
        void navigate(to, {
          replace: true,
          preventScrollReset: opts?.scroll === false,
        });
      },
      refresh: () => {
        window.location.reload();
      },
      back: () => void navigate(-1),
      prefetch: (_href: string) => {
        void _href;
        return Promise.resolve();
      },
    }),
    [navigate],
  );
}

export function usePathname() {
  return useLocation().pathname;
}

export function useSearchParams(): URLSearchParams {
  const [params] = useRouterSearchParams();
  return params;
}
